/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import _ from 'lodash';
import PapaParse from 'papaparse';
import { IAnyObject } from '../../PerformanceGraph/IPerformanceGraph';

export const handleManualUploadClick = (
  acceptedFiles: File[],
  SelectedDataTye: string,
  uploadType: string,
  OnUploadClick?: Function
) => {
  if (OnUploadClick) {
    OnUploadClick(acceptedFiles, SelectedDataTye, uploadType);
  }
};

export const getActivetabClassName = (activeIndex: number, index: number) => {
  if (activeIndex === index) return 'modal-tab-active-header pb-10';
  else return 'pb-10';
};

export const getStepperBadgeColor = (
  activeIndex: number,
  currentIndex: number
) => {
  if (activeIndex == currentIndex) return 'blue';
  else return 'grey';
};

export const validateLargeCSVFileHeaders = (file: File, headers?: string[]) =>
  new Promise<boolean>((res, rej) => {
    if (!file) rej('No File');
    if (!headers) res(true);
    PapaParse.parse(file, {
      header: true,
      skipEmptyLines: true,
      step: function(rows: PapaParse.ParseStepResult<IAnyObject>, parser) {
        parser.pause();
        let header_row = _.toLower(Object.keys(rows.data).join(','));
        res(_.every(headers, (h) => header_row.includes(_.toLower(h))));
        parser.abort();
      },
      error: function(err) {
        rej(err);
      }
    });
  });
